import { getCleanUrl } from 'js/utils/url.util';
import { languageService } from 'js/services/language.service';

const isAnyLangs = (langs) => {
    const clearLangs = langs.filter((lang) => lang.trim());

    return !clearLangs.length || clearLangs.includes('*');
};

export const isWhiteListed = (list = [], config = '') => {
    const buildRegexp = (str) => {
        const reg = str
            .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
            .replace(/\*/g, '.*');

        return `^${reg}$`;
    };

    return list.some(item => new RegExp(buildRegexp(item), 'i').test(config));
};

export const platformFilter = formFactor => rule => rule[formFactor];

export const scheduleFilter = () => (rule) => {
    const now = Date.now();
    const { endTime, startTime } = rule;

    return !(endTime && now >= endTime) && !(startTime && startTime >= now);
};

export const countryFilter = country => rule => rule.countries.length === 1 && rule.countries[0] === '*'
    || rule.excluded ? !rule.countries.includes(country) : rule.countries.includes(country);

export const languageFilter = ({ userLang, pathLang, localeAlias }) => (rule) => {
    if (isAnyLangs(rule.languages)) {
        return true;
    }

    const lang = localeAlias || languageService.getShortLanguage(userLang);

    if (pathLang && pathLang !== lang) {
        return false;
    }

    const languages = rule.languages.map(language => language.toLowerCase());

    return rule.excludedLang
        ? !languages.includes(lang.toLowerCase())
        : languages.includes(lang.toLowerCase());
};

export const addPageRegexp = (rule) => {
    const fromPages = rule.fromPages.map(page => {
        let fromPage = page[0] !== '/' ? `/${page}` : page;

        fromPage = fromPage.replace('/*', '/(.*)');

        return fromPage;
    });

    return { ...rule, fromPages };
};

export const shouldExclude = (fromPage, toPage, languagePage) => {
    const url = getCleanUrl();

    return url === toPage && new RegExp(`^${fromPage.replace('(.*)', '.*')}$`).test(url)
        || url === languagePage && fromPage !== languagePage;
};

export const hasConflictWithForwardRoot = ({ fromPage, toPage, forwardRootPage, rootPage }) => {
    if (!forwardRootPage) {
        return false;
    }

    return fromPage === rootPage && toPage === '/';
};
